<template>
  <!-- Table Container Card -->
  <b-card no-body>
    <!-- Delete Model -->
    <b-modal
      :no-close-on-backdrop="true"
      id="modal-delete"
      title="Delete User"
      ok-only
      ok-title="Delete"
      @ok="deleteItem"
    >
      <b-card-text>
        <h5>Are You Sure To Remve This User</h5>
        If you want to remove this user, click the button below.
      </b-card-text>
    </b-modal>
    <!-- Edit modal -->
    <b-modal
      :no-close-on-backdrop="true"
      id="modal-edit"
      ok-only
      centered
      size="lg"
      title="Eidt User"
      @ok="updateItem()"
    >
      <b-card-text>
        <br />
        <b-row>
          <b-col md="6">
            <b-form-group>
              <b-form-input v-model="EditForm.name" placeholder="Name" />
            </b-form-group>
          </b-col>
        </b-row>
      </b-card-text>
    </b-modal>
    <!-- add Page -->
    <div class="m-2">
      <b-row>
        <b-col
          cols="12"
          md="12"
          class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
        >
          <b-button
            @click="$router.push({ name: 'add-page-permissions' })"
            variant="primary"
          >
            Add Page Permissions
          </b-button>
        </b-col>
      </b-row>
    </div>
    <div class="m-2">
      <!-- Search -->
      <b-row>
        <b-col md="6">
          <b-form-group label="Page Name">
            <b-form-input v-model="filterData.name" placeholder="Enter Name" />
          </b-form-group>
        </b-col>
      </b-row>
    </div>
    <div class="m-2">
      <b-row>
        <b-col
          cols="12"
          md="12"
          class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
        >
          <b-button variant="primary" @click="index()"> Search </b-button>
        </b-col>
      </b-row>
    </div>

    <!-- Data Table  -->
    <b-table
      :items="usersData"
      responsive
      :fields="tableColumns"
      primary-key="id"
      show-empty
      empty-text="No matching records found"
      class="position-relative"
      v-if="!loading"
    >
      <!-- Column: Id -->
      <template #cell(id)="data">
        <b-link
          :to="{ name: 'city', params: { id: data.item.id } }"
          class="font-weight-bold"
        >
          {{ data.item.id }}
        </b-link>
      </template>

      <!-- Column: Name -->
      <template #cell(Name)="data">
        <b-media vertical-align="center">
          <span class="font-weight-bold d-block text-nowrap">
            {{ data.item.name }}
          </span>
        </b-media>
      </template>

      <!-- Column: Actions -->
      <template #cell(actions)="data">
        <div class="text-nowrap">
          <!-- <b-button variant="outline-primary" @click="
            $router.push({
              name: 'users-preview',
              params: { id: data.item.id },
            })
          ">
            Permissions
          </b-button> -->
          <!-- Dropdown -->
          <b-dropdown
            variant="link"
            toggle-class="p-0"
            no-caret
            :right="$store.state.appConfig.isRTL"
          >
            <template #button-content>
              <feather-icon
                icon="MoreVerticalIcon"
                size="16"
                class="align-middle text-body"
              />
            </template>
            <b-dropdown-item @click="show(data.item)">
              <feather-icon icon="EditIcon" />
              <span class="align-middle ml-50">Edit</span>
            </b-dropdown-item>
            <b-dropdown-item @click="deleteModel(data.item)">
              <feather-icon icon="TrashIcon" />
              <span class="align-middle ml-50">Delete</span>
            </b-dropdown-item>
          </b-dropdown>
        </div>
      </template>
    </b-table>
    <template v-if="loading">
      <div>
        <div class="d-flex justify-content-center mb-1">
          <b-spinner label="Loading..." />
        </div>
      </div>
    </template>
    <div class="mx-2 mb-2">
      <b-row>
        <b-col
          cols="12"
          sm="6"
          class="d-flex align-items-center justify-content-center justify-content-sm-start"
        >
          <span class="text-muted">Showing 1 to 10 entries</span>
        </b-col>
        <!-- Pagination -->
        <b-col
          cols="12"
          sm="6"
          class="d-flex align-items-center justify-content-center justify-content-sm-end"
          @click="index()"
        >
          <b-pagination
            v-model="page"
            :total-rows="totalRows"
            :per-page="take"
            first-number
            last-number
            class="mb-0 mt-1 mt-sm-0"
            prev-class="prev-item"
            next-class="next-item"
          >
            <template #prev-text>
              <feather-icon icon="ChevronLeftIcon" size="18" />
            </template>
            <template #next-text>
              <feather-icon icon="ChevronRightIcon" size="18" />
            </template>
          </b-pagination>
        </b-col>
      </b-row>
    </div>
  </b-card>
</template>

<script>
import {
  BCard,
  BRow,
  BCol,
  BFormInput,
  BButton,
  BTable,
  BMedia,
  BAvatar,
  BLink,
  BBadge,
  BDropdown,
  BDropdownItem,
  BPagination,
  BTooltip,
  BFormGroup,
  BFormSelect,
  BSpinner,
  BModal,
  BAlert,
  VBModal,
  BCardText,
} from 'bootstrap-vue';
import vSelect from 'vue-select';
import { onUnmounted } from '@vue/composition-api';
import store from '@/store';
import Ripple from 'vue-ripple-directive';
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue';

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BTooltip,
    vSelect,
    BFormGroup,
    BFormSelect,
    BSpinner,
    BModal,
    BAlert,
    BCardText,
  },
  directives: {
    'b-modal': VBModal,
    Ripple,
  },
  data() {
    return {
      tableColumns: [
        { key: 'Id', label: '#', sortable: true },
        { key: 'Name', sortable: true },
        { key: 'Actions' },
      ],
      EditForm: {
        name: '',
        _method: 'PUT',
      },
      editId: '',
      take: 10,
      loading: true,
      selected: '',
      totalInvoices: 0,
      option: [],
      currentPage: 1,
      takeOptions: [10, 25, 50, 100],
      searchQuery: '',
      sortBy: 'id',
      isSortDirDesc: true,
      totalRows: '',
      page: 1,
      params: {
        form: {},
        path: '',
      },
      deleteForm: [],
      statusFilter: null,
      departmentList: [],
      jobTitleList: [],
      usersData: '',
      filterData: {
        name: '',
      },
    };
  },
  mounted() {
    this.index();
  },
  methods: {
    show(item) {
      this.EditForm.name = item.name;
      this.$bvModal.show('modal-edit');
    },
    deleteModel(item) {
      this.deleteForm = item;
      this.$bvModal.show('modal-delete');
    },
    async index() {
      await this.getList(
        `/page?take=${this.take}&page=${this.page}&filter[name]=${this.filterData.name}`
      );
      this.usersData = this.all_data.data;
      this.totalRows = this.all_data.total;
      this.loading = false;
    },

    updateItem() {
      (this.params.form = this.EditForm),
        (this.params.path = `/page/${this.editId}`),
        this.$store
          .dispatch('update', this.params)
          .then((response) => {
            this.index();
          })
          .catch((error) => {
            if (error.response.status === 400) {
              for (let item in error.response.data) {
                this.$toast({
                  component: ToastificationContent,
                  position: 'top-right',
                  props: {
                    title: 'validation error',
                    variant: 'danger',
                    text: error.response.data[item][0],
                  },
                });
              }
            }
          });
    },
    deleteItem() {
      this.$store
        .dispatch('delete', `/page/${this.deleteForm.id}`)
        .then((response) => {
          this.index();
          this.$toast({
            component: ToastificationContent,
            position: 'top-right',
            props: {
              title: 'Delete Success',
              icon: 'success',
              variant: 'info',
              text: 'deleted ' + this.deleteForm.name + ' successfully',
            },
          });
        })
        .catch((error) => {
          this.$toast({
            component: ToastificationContent,
            position: 'top-right',
            props: {
              title: 'Error',
              variant: 'danger',
              text: 'Error deleting ' + this.deleteForm.name,
            },
          });
        });
    },
  },
};
</script>

<style lang="scss" scoped></style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
